
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SET_MANAGER_ACCESSED_TO_CONTRACTOR from "@/apollo/managers/AddContractorToManagers.gql";

  import AddEmployeeModal from "@/components/common/AddEmployeeModalNew.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
  import { NOTIFICATION } from "@/entities/Events";

  import Message from "@/data/notificationsMessages";

  interface ContractorAddToManagers {
    contractor_id: string;
    manager_id: string;
    created_by: string;
  }

  @Component({
    components: {
     UiButtonMessage,
      AddEmployeeModal,
      ManagersMultiselect,
    },
  })
  export default class AddContractorToManager extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, default: undefined }) readonly buttonSize?: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    conditions: Object = {
      _and: [
        {
          _not: {
            contractors: {
              contractor_id: { _eq: this.contractorId },
            },
          },
        },
      ],
    };

    modalShown: boolean = false;
    selectedManagersIds: string[] = [];

    get isSelected(): boolean {
      return this.selectedManagersIds.length > 0;
    }

    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }

    contractorAddedToManager(): void {
      this.closeModal();
      this.selectedManagersIds = [];
      this.$emit("contractorWasAddedToManager");
    }

    async addContractorToManagers(): Promise<void> {
      const contractorAddToManagers = this.selectedManagersIds.map(managerId => ({
        contractor_id: this.contractorId,
        manager_id: managerId,
        approved: true,
        created_by: this.currentUserId,
      }));

      try {
        await this.setManagerAccessToContractor(contractorAddToManagers);

        this.contractorAddedToManager();
        this.$eventBus.emit(NOTIFICATION, Message.successMessage("Access has been granted"));
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      }
    }

    private setManagerAccessToContractor(contractorAddToManagers: ContractorAddToManagers[]) {
      return this.$apollo.mutate({
        mutation: SET_MANAGER_ACCESSED_TO_CONTRACTOR,
        variables: {
          objects: contractorAddToManagers,
        },
      });
    }
  }
